// extracted by css-extract-rspack-plugin
export default {"UpsellCardComponent":"xFIVb","Large":"Sc4Uf","MainStack":"zrDRG","Default":"dxVBn","Title":"JFW_v"};